export const ASILIFLOW_PLAN_NAME = 'AsiliFlow'
export const ASILIFLOW_MONTHLY_PRICE = 299.99
export const ASILIFLOW_MONTHLY_PRICE_LABEL = '$299.99'
export const ASILIFLOW_MONTHLY_PRICE_CENTS = 29999
